export default "__VITE_ASSET__Qsdck50V__"